import type { SVGProps } from 'react'
const SvgSyExchangeFunds = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M16.3,19.8c-1.3.7-2.8,1.1-4.3,1.1-1.5,0-3-.4-4.4-1.2-2.8-1.6-4.4-4.6-4.4-7.7,0-1.2.2-2.3.7-3.4h0c0-.1,1.3.6,1.3.6l-.2-4.7L.8,6.7l1.4.8h0c-.6,1.5-1,3-1,4.5,0,3.7,1.9,7.4,5.4,9.4,1.7,1,3.6,1.5,5.4,1.5,1.8,0,3.7-.5,5.3-1.4l-1-1.7Z" />
		<polygon points="13.5 12.2 10.5 9.1 6 13.5 7.4 14.9 10.5 11.8 13.5 14.9 18 10.5 16.6 9.1 13.5 12.2" />
		<path d="M23.2,17.3l-1.4-.8h0c.6-1.5,1-3,1-4.5,0-3.7-1.9-7.4-5.4-9.4-1.7-1-3.6-1.5-5.4-1.5-1.8,0-3.7.5-5.3,1.4l1,1.7c1.3-.7,2.8-1.1,4.3-1.1,1.5,0,3,.4,4.4,1.2,2.8,1.6,4.4,4.6,4.4,7.7,0,1.2-.2,2.3-.7,3.4h0c0,.1-1.3-.6-1.3-.6l.2,4.7,4.2-2.2Z" />
	</svg>
)
export default SvgSyExchangeFunds
